<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 产品管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>产品库存</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.productName" placeholder="产品名称" class="handle-input mr10"></el-input>
				<el-select v-model="query.stockStatus" placeholder="请选择库存状况">
					<el-option key="" label="请选择库存状况" value=""></el-option>
					<el-option key="0" label="正常库存" value="0"></el-option>
					<el-option key="1" label="异常库存" value="1"></el-option>
				</el-select>&nbsp;&nbsp;
				<el-select v-model="query.sharingType" placeholder="请选择共享状况">
					<el-option key="" label="请选择共享状况" value=""></el-option>
					<el-option key="0" label="未共享" value="0"></el-option>
					<el-option key="1" label="共享给所有公司" value="1"></el-option>
					<el-option key="2" label="共享给子公司" value="2"></el-option>
				</el-select>&nbsp;&nbsp;
				<el-checkbox v-model="query.inStock" name="inStock">只显示有库存的</el-checkbox>&nbsp;&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
			
			<el-tabs v-model="activeTab" type="card">
				<el-tab-pane label="本地库存" name="localTab" style="margin-top:10px">
					<el-table
						:data="localData"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						@selection-change="handleSelectionChange"
						stripe
					>
						<el-table-column type="selection" width="50" align="center"></el-table-column>
						<el-table-column prop="productName" label="产品名称" width = "200px"></el-table-column>
						<el-table-column prop="id" label="库存编号" width = "80px">
							<template slot-scope="scope">
								{{scope.row.id}}号
							</template>
						</el-table-column>
						<el-table-column prop="price" label="入库价" v-if="showPurchasePrice"></el-table-column>
						<el-table-column prop="stockNum" label="库存量" width = "80px">
							<template slot-scope="scope">
								<el-tag :type='scope.row.purchaseNum - scope.row.shipmentNum === scope.row.stockNum?"success":"danger"'>{{scope.row.stockNum}}</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="limitPrice" label="最低出库价"></el-table-column>
						<el-table-column prop="purchaseNum" label="累计入库"></el-table-column>
						<el-table-column prop="lastPurchaseTime" label="最近入库时间" width = "160px"></el-table-column>
						<el-table-column prop="shipmentNum" label="累计出库"></el-table-column>
						<el-table-column prop="lastShipmentTime" label="最近出库时间" width = "160px"></el-table-column>
						<el-table-column prop="sharingType" label="共享状况" width = "130px">
							<template slot-scope="scope">
								{{scope.row.sharingType==1?"共享给所有公司":scope.row.sharingType==2?"共享给子公司":"未共享"}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180" align="center">
							<template slot-scope="scope">
								<el-button
									type="text"
									icon="el-icon-setting"
									@click="handleEdit(scope.$index, scope.row)"
									v-if = "controll['edit']"
								>设置</el-button>
								<el-button
									type="text"
									icon="el-icon-edit"
									@click="handleCorrect(scope.$index, scope.row)"
									v-if = "controll['correct']"
								>纠偏</el-button> &nbsp;
								<router-link  :to="{path:'/change-record',query:{stockId:scope.row.id}}" v-if="controll['change-record']">
								<el-button
									type="text"
									icon="el-icon-tickets"
									v-if="controll['change-record']"
								>记录</el-button></router-link>
							</template>
						</el-table-column>
					</el-table>
					
					<div class="record-a-d">
						<el-button
							type="warning"
							icon="el-icon-open"
							class="handle-del mr10"
							@click="handleSharing"
							v-if="controll['sharing']"
						>共享</el-button>
						<el-button
							type="primary"
							icon="el-icon-turn-off"
							class="handle-del mr10"
							@click="handleCancelSharing"
							v-if="controll['unsharing']"
						>取消共享</el-button>
					</div>
					<div class="pagination">
						<el-pagination
							background
							layout="total, prev, pager, next"
							:current-page="localPageIndex"
							:page-size="localPageSize"
							:total="localPageTotal"
							@current-change="handleLocalPageChange"
						></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="内部库存" name="internalTab" style="margin-top:10px" v-if="internalData.length > 0">
					<el-table
						:data="internalData"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						stripe
					>
						<el-table-column prop="companyName" label="公司名称" width = "320px"></el-table-column>
						<el-table-column prop="brandName" label="产品品牌" width = "120px"></el-table-column>
						<el-table-column prop="seriesName" label="产品名称"></el-table-column>
						<el-table-column prop="productName" label="产品名称" width = "240px"></el-table-column>
						<el-table-column prop="stockNum" label="库存量" width = "100px"></el-table-column>
						<el-table-column prop="contact" label="联系人" width = "120px"></el-table-column>
						<el-table-column prop="tel" label="联系电话" width = "200px"></el-table-column>
					</el-table>
					
					<div class="pagination">
						<el-pagination
							background
							layout="total, prev, pager, next"
							:current-page="internalPageIndex"
							:page-size="internalPageSize"
							:total="internalPageTotal"
							@current-change="handleInternalPageChange"
						></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="共享库存" name="sharingTab" style="margin-top:10px" v-if="sharingData.length > 0">
					<el-table
						:data="sharingData"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						stripe
					>
						<el-table-column prop="companyName" label="公司名称"></el-table-column>
						<el-table-column prop="brandName" label="产品品牌" width = "120px"></el-table-column>
						<el-table-column prop="seriesName" label="产品系列" width = "280px"></el-table-column>
						<el-table-column prop="productName" label="产品名称" width = "180px"></el-table-column>
						<el-table-column prop="stockNum" label="库存量" width = "100px"></el-table-column>
						<el-table-column prop="contact" label="联系人" width = "120px"></el-table-column>
						<el-table-column prop="tel" label="联系电话" width = "200px"></el-table-column>
					</el-table>
					
					<div class="pagination">
						<el-pagination
							background
							layout="total, prev, pager, next"
							:current-page="sharingPageIndex"
							:page-size="sharingPageSize"
							:total="sharingPageTotal"
							@current-change="handleSharingPageChange"
						></el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="产品名称" prop="productName">
                    <el-input v-model="form.productName" :disabled = true></el-input>
                </el-form-item>
				<el-form-item label="入库价" prop="price">
					<el-input v-model="form.price" :disabled = true></el-input>
				</el-form-item>
				<el-form-item label="最低出库价" prop="limitPrice">
					<el-input v-model="form.limitPrice"></el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="setPrice" v-prevent-re-click>设置</el-button>
            </span>
			
        </el-dialog>
		
		<!-- 纠偏弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="库存纠偏" :visible.sync="correctVisible" width="40%">
            <el-form ref="form" :model="correct" label-width="120px">
				<el-form-item label="产品名称" prop="productName">
                    <el-input v-model="correct.productName" :disabled = true></el-input>
                </el-form-item>
				<el-form-item label="库存数量" prop="stockNum">
					<el-input v-model="correct.stockNum" :disabled = true></el-input>
				</el-form-item>
				<el-form-item label="纠偏数量" prop="correctNum">
					<el-input-number v-model="correct.correctNum" :min="-100" :max="100"></el-input-number>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input type=textarea :rows=3 v-model="correct.remark"> </el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="correctVisible = false">取 消</el-button>
                <el-button type="primary" @click="correctStock" v-prevent-re-click>确定</el-button>
            </span>
        </el-dialog>
		
		<!-- 共享弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="共享设置" :visible.sync="sharingVisible" width="40%">
            <el-form ref="share" :model="share" label-width="120px" :rules="sharRules">
				<el-form-item label="共享方式" prop="sharingType">
                    <el-select v-model="share.sharingType" placeholder="请选择共享方式">
						<el-option key="" label="请选择共享方式" value=""></el-option>
						<el-option key="1" label="共享给所有公司" value="1"></el-option>
						<el-option key="2" label="共享给子公司" value="2" v-if="isGroupCompany"></el-option>
					</el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="sharingVisible = false">取 消</el-button>
                <el-button type="primary" @click="sharing" v-prevent-re-click>确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchStockData, getStock, setLimitPrice, correctStockNum, getStockControlParam, 
stockSharing, stockUnsharing, fetchLocalStockData, fetchInternalStockData, fetchSharingStockData } from '../../../api/index';
export default {
    name: 'stock',
    data() {
        return {
            query: {
                pageNum:1,
				pageSize:10
            },
            localData: [],
            editVisible: false,
			correctVisible: false,
			localPageNum: 1,
			localPageSize: 10,
			internalPageNum: 1,
			internalPageSize: 10,
			sharingPageNum: 1,
			sharingPageSize: 10,
            localPageTotal: 0,
			internalPageTotal: 0,
			sharingPageTotal: 0,
			localPageIndex:1,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			rules: {
                limitPrice: [{ required: true, message: '最低出库价不能为空', trigger: 'blur' }]
            },
			sharRules : {
				sharingType: [{ required: true, message: '请选择共享方式不能为空', trigger: 'blur' }]
			},
			correct:{},
			controll:{},
			showPurchasePrice:false,
			multipleSelection:[],
			sharingVisible:false,
			isGroupCompany:false,
			share:{},
			activeTab:"localTab",
			internalData:[],
			sharingData:[]
        };
    },
    created() {
		this.controll = getControll("stock");
		this.getControlParam();
        this.getStockData();
    },
    methods: {	
		// 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		getControlParam() {
			getStockControlParam().then(res => {
				if (res.code == 0) {
					this.showPurchasePrice = res.data["showPurchasePrice"];
					this.isGroupCompany = res.data["groupCompany"];
				} else {
					this.$message.error(`获取控制参数失败！` + res.message);
				}
			});
		},
        // 获取所有库存数据
        getStockData() {
            fetchStockData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.localData = res.data.localData.records;
					this.localPageTotal = res.data.localData.total;
					this.internalData = res.data.internalData.records;
					this.internalPageTotal = res.data.internalData.total;
					this.sharingData = res.data.sharingData.records;
					this.sharingPageTotal = res.data.sharingData.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		//获取本地库存数据
		getLocalStockData() {
            fetchLocalStockData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.localData = res.data.records;
					this.localPageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		//获取内部库存数据
		getInternalStockData() {
            fetchInternalStockData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.internalData = res.data.records;
					this.internalPageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		//获取本地缓存数据
		getSharingStockData() {
            fetchSharingStockData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.SharingData = res.data.records;
					this.SharingPageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		initQuery(pageNum) {
			this.$set(this.query, "pageNum", pageNum);
		},
        // 触发搜索按钮
        handleSearch() {
            this.localPageNum=1;
			this.localPageIndex=1;
			this.internalPageNum=1;
			this.internalPageIndex=1;
			this.sharingPageNum=1;
			this.sharingPageIndex=1;
			this.initQuery(1);
            this.getStockData(this.query);
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			getStock(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		handleCorrect(index, row) {
            this.idx = index;
			getStock(row.id).then(res => {
				if (res.code == 0) {
					this.correct = res.data;
					this.correctVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 分页导航
        handleLocalPageChange(val) {
            this.localPageNum = val;
			this.localPageIndex = val;
			this.initQuery(val);
            this.getLocalStockData(this.query);
        },
		handleInternalPageChange(val) {
            this.internalPageNum=val;
			this.internalPageIndex=val;
			this.initQuery(val);
            this.getInternalStockData(this.query);
        },
		handleSharingPageChange(val) {
            this.sharingPageNum=val;
			this.sharingPageIndex=val;
			this.initQuery(val);
            this.getSharingStockData(this.query);
        },
		setPrice() {
			let data = {};
			data["id"] = this.form["id"];
			data["limitPrice"] = this.form["limitPrice"];
			setLimitPrice(data).then(res => {
				if (res.code == 0) {
					this.$message.success(`设置成功！`);
					this.editVisible = false;
					this.$set(this.localData, this.idx, this.form);
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		correctStock() {
			let data = {};
			data["id"] = this.correct["id"];
			data["correctNum"] = this.correct["correctNum"];
			data["remark"] = this.correct["remark"];
			correctStockNum(data).then(res => {
				if (res.code == 0) {
					this.$message.success(`设置成功！`);
					this.correctVisible = false;
					this.getLocalStockData();
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		handleSharing() {
			let ids = this.getIds();
			if (ids.length == 0) {
				return;
			}
			this.sharingVisible = true;
			this.$set(this.share, "ids", ids);
			this.$set(this.share, "sharingType", "");
		},
		sharing() {
			this.$refs.share.validate(valid => {
				if (valid) {
					stockSharing(this.share).then(res => {
						if (res.code == 0) {
							this.$message.success('共享成功！');
							this.sharingVisible = false;
							this.getLocalStockData();
						} else {
							this.$message.error(`共享失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		handleCancelSharing() {
			let ids = this.getIds();
			if (ids.length == 0) {
				return;
			}
			this.$confirm('确定要取消共享吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					stockUnsharing(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('取消共享成功');
							this.getLocalStockData();
						} else {
							this.$message.error(`取消共享失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
		getIds(){
			let ids = [];
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要操作的记录！`);
				return ids;
			}           
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			return ids;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
